// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  slug: __t.string(),
  category: __t.string(),
  name: __t.string(),
  description: __t.string(),
  priceCoins: __t.i64().name("price_coins"),
  rarity: __t.string(),
  isAvailable: __t.bool().name("is_available"),
  isSeasonal: __t.bool().name("is_seasonal"),
  previewAsset: __t.string().name("preview_asset"),
  createdAt: __t.u64().name("created_at"),
  availableFrom: __t.u64().name("available_from"),
  availableUntil: __t.u64().name("available_until"),
  assetData: __t.option(__t.string()).name("asset_data"),
});
